import React, { useState, useEffect } from 'react';

const SpecialOffer = ({ isVisible, onClose }) => {
  const [timeLeft, setTimeLeft] = useState(600); // 10 minutes in seconds

  useEffect(() => {
    if (!isVisible) return;

    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onClose();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isVisible, onClose]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-60 backdrop-blur-sm"
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div className="relative bg-white rounded-2xl sm:rounded-3xl shadow-2xl max-w-2xl w-full overflow-hidden animate-bounce-in max-h-[95vh] sm:max-h-[90vh]">
        {/* Header with animated background */}
        <div className="relative bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 text-white p-4 sm:p-6 lg:p-8 overflow-hidden">
          {/* Animated sparkles */}
          <div className="absolute inset-0">
            {[...Array(20)].map((_, i) => (
              <div
                key={i}
                className="absolute w-1 h-1 bg-white rounded-full animate-ping"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 2}s`,
                  animationDuration: `${1 + Math.random()}s`
                }}
              ></div>
            ))}
          </div>

          <div className="relative z-10 text-center">
            <div className="text-4xl sm:text-5xl lg:text-6xl mb-2 sm:mb-4 animate-bounce">
              <i className="bi bi-stars"></i>
            </div>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-1 sm:mb-2">
              LIMITED TIME OFFER!
            </h2>
            <p className="text-yellow-100 text-sm sm:text-base lg:text-lg px-2">
              Exclusive consultation package for engaged visitors
            </p>
          </div>
        </div>

        {/* Countdown Timer */}
        <div className="bg-gradient-to-r from-red-50 to-orange-50 border-l-4 border-red-500 p-3 sm:p-4">
          <div className="text-center">
            <div className="text-red-600 font-bold text-base sm:text-lg mb-1">
              ⏰ Special Offer Expires In: {formatTime(timeLeft)}
            </div>
            <div className="text-red-500 text-xs sm:text-sm">
              Don't miss this exclusive opportunity!
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-4 sm:p-6 lg:p-8 custom-scrollbar overflow-y-auto max-h-[50vh] sm:max-h-none">
          <div className="text-center mb-6 sm:mb-8">
            <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-secondary-900 mb-3 sm:mb-4">
              Complete Campaign Success Package
            </h3>
            <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-primary-600 mb-1 sm:mb-2">
              <span className="line-through text-secondary-500 text-lg sm:text-xl lg:text-2xl mr-1 sm:mr-2">KES 150,000</span>
              KES 75,000
            </div>
            <div className="text-green-600 font-semibold text-sm sm:text-base">50% OFF - Limited Time!</div>
          </div>

          {/* Package includes */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-6 sm:mb-8">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-4 sm:p-6 rounded-xl border border-blue-200">
              <div className="text-blue-600 text-xl sm:text-2xl mb-2 sm:mb-3">
                <i className="bi bi-search"></i>
              </div>
              <h4 className="font-bold text-secondary-900 mb-1 sm:mb-2 text-sm sm:text-base">Strategy Assessment</h4>
              <p className="text-secondary-600 text-xs sm:text-sm">Comprehensive campaign analysis and strategic recommendations</p>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-green-100 p-4 sm:p-6 rounded-xl border border-green-200">
              <div className="text-green-600 text-xl sm:text-2xl mb-2 sm:mb-3">
                <i className="bi bi-bar-chart"></i>
              </div>
              <h4 className="font-bold text-secondary-900 mb-1 sm:mb-2 text-sm sm:text-base">Voter Analytics</h4>
              <p className="text-secondary-600 text-xs sm:text-sm">Advanced voter segmentation and targeting insights</p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-4 sm:p-6 rounded-xl border border-purple-200">
              <div className="text-purple-600 text-xl sm:text-2xl mb-2 sm:mb-3">
                <i className="bi bi-megaphone"></i>
              </div>
              <h4 className="font-bold text-secondary-900 mb-1 sm:mb-2 text-sm sm:text-base">Digital Strategy</h4>
              <p className="text-secondary-600 text-xs sm:text-sm">Complete digital campaign planning and social media strategy</p>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 sm:p-6 rounded-xl border border-orange-200">
              <div className="text-orange-600 text-xl sm:text-2xl mb-2 sm:mb-3">
                <i className="bi bi-person-check"></i>
              </div>
              <h4 className="font-bold text-secondary-900 mb-1 sm:mb-2 text-sm sm:text-base">Personal Coaching</h4>
              <p className="text-secondary-600 text-xs sm:text-sm">One-on-one coaching with senior political strategists</p>
            </div>
          </div>

          {/* Bonus items */}
          <div className="bg-gradient-to-r from-yellow-50 to-yellow-100 border-2 border-yellow-300 border-dashed rounded-xl p-6 mb-8">
            <h4 className="font-bold text-yellow-800 mb-3 text-center">🎁 BONUS ITEMS INCLUDED:</h4>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
              <div className="text-center">
                <div className="text-2xl mb-2">
                  <i className="bi bi-clipboard-check"></i>
                </div>
                <div className="font-semibold text-yellow-800">Campaign Playbook</div>
                <div className="text-yellow-600">Digital PDF guide</div>
              </div>
              <div className="text-center">
                <div className="text-2xl mb-2">
                  <i className="bi bi-bar-chart"></i>
                </div>
                <div className="font-semibold text-yellow-800">Analytics Dashboard</div>
                <div className="text-yellow-600">30-day access</div>
              </div>
              <div className="text-center">
                <div className="text-2xl mb-2">📞</div>
                <div className="font-semibold text-yellow-800">Priority Support</div>
                <div className="text-yellow-600">Direct strategist access</div>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="space-y-3 sm:space-y-4">
            <button className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold py-3 sm:py-4 px-4 sm:px-6 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl animate-pulse text-sm sm:text-base">
              <i className="bi bi-rocket mr-1 sm:mr-2"></i>
              <span className="hidden sm:inline">CLAIM THIS OFFER NOW - </span>SAVE KES 75,000!
            </button>

            <div className="text-center">
              <button
                onClick={onClose}
                className="text-secondary-500 hover:text-secondary-700 underline text-xs sm:text-sm"
              >
                No thanks, I'll do it later
              </button>
            </div>
          </div>

          {/* Trust indicators */}
          <div className="mt-8 pt-6 border-t border-secondary-200">
            <div className="text-center text-secondary-600 text-sm">
              <div className="flex items-center justify-center space-x-6 mb-3">
                <div className="flex items-center">
                  <i className="bi bi-shield-check text-green-600 mr-1"></i>
                  <span>100% Confidential</span>
                </div>
                <div className="flex items-center">
                  <i className="bi bi-clock text-blue-600 mr-1"></i>
                  <span>24h Response</span>
                </div>
                <div className="flex items-center">
                  <i className="bi bi-star text-yellow-600 mr-1"></i>
                  <span>4.9/5 Rating</span>
                </div>
              </div>
              <p>Join 500+ successful political leaders who trusted our expertise</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecialOffer;